// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
//import { useState, useEffect, useRef, forwardRef } from 'react'
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'

import * as THREE from "three";

// import { isSmallAtom } from "../atoms";
import {isSmallAtom,isThreeFlagLoadingAtom,isAnimationsPausedAtom} from '../atoms/atom.config.js'

import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth } from '../constants';
import { render } from "@testing-library/react";

// assets
//import flagImage from '../assets/images/default_thumb.jpg' //button_mobile_menu.svg
// import logoImage2 from './default_thumb.jpg'
//import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'


// https://maxrozen.com/learn-useeffect-dependency-array-react-hooks
// https://www.developerway.com/posts/react-re-renders-guide

const ThreeFlag = forwardRef((props,ref) => {
//export default function ThreeFlag(props) {

    const [isSmall, setIsSmall] = useAtom(isSmallAtom);
    const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);

    //const [isThreeFlagLoading, setIsThreeFlagLoading] = useAtom(isThreeFlagLoadingAtom); // using parent state now
    const mountRef = useRef(null);
    //console.log("ThreeFlag0", props)
    let maxw = 729;// 996;// 729; //820;
    let maxh = 300; //410; //498; //410; //300; //410;

    // threejs objects
    let materialA = null;
    let materialB = null;
    let imageA = null;
    let imageB = null;
    let geometry = null;
    let mesh = null;
    let scene = null;
    let camera = null;
    let renderer = null;//useRef(null); //null;
    let clock = null;

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/cancelAnimationFrame
    let animReq = useRef(false);
  
    //let fadeOut = false
    //const [fadeOut, setFadeOut] = useState(false);
    const fadeOut = useRef(false)
    const fadeIn = useRef(false)
    const fadeSpeed = 0.03;

    const setFadeOut = (v) => {
        //fadeOut = v;
        fadeOut.current = v;
    }
    const setFadeIn = (v) => {
        //fadeOut = v;
        fadeIn.current = v;
    }

    const swapMaterial = () => {
        console.log(scene);
        console.log("swapMaterial", fadeOut.current, fadeIn.current); //, (mesh.material == materialA))
        //fadeOut = true;
        setFadeOut(true);
        // if(!mesh) return
        // if(mesh.material == materialA) {
        //     mesh.material = materialB
        // } else {
        //     mesh.material = materialA
        // }
        
    };

    // const animate = () => {
    //     console.log("fading out", fadeOut)
    // };

    // can call these methods from parent with useRef, but CANT call internally with gotoSlide(1)
    // this is not working after a state change with new scene
    useImperativeHandle(ref, () => {
        return { 
            swapMaterialMod: () => swapMaterial()
        }
    })

    //https://gist.github.com/xposedbones/75ebaef3c10060a3ee3b246166caab56
    const mapValue = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2;

    function loadTextures(urls, callback) {

        var textures = [];
    
        var onLoad = function() {
            callback(null, textures);
        };
    
        var onProgress = function() {};
    
        var onError = function(url) {
            callback(new Error('Cannot load ' + url));
        };
    
        var manager = new THREE.LoadingManager(onLoad, onProgress, onError);
    
        var loader = new THREE.TextureLoader(manager);

        
    
        for (var i=0; i<urls.length; i++) {
            textures.push(loader.load(urls[i]));
        }

        
    }

    function sceneReady() {

    }

    // function getClockTime(clock) {
    //     console.log("getClockTime isAnimationPaused", isAnimationPaused)
    //     if(clock) {
    //         return clock.getElapsedTime()
    //     }
    //     return 1.0        
    // }

    function animate() {
        if(!mesh) {
            animReq.current = requestAnimationFrame( animate ); //animReq =
            return;
        }
    //var animate2 = function () {
        // requestAnimationFrame( animate );
        // cube.rotation.x += 0.01;
        // cube.rotation.y += 0.01;
        // renderer.render( scene, camera );
        const t = (isAnimationPaused) ? 1.0 : clock.getElapsedTime()
        //console.log(isAnimationPaused, t);
        //const t= getClockTime(clock)
        // const t = clock.getElapsedTime()
        //console.log(t, isAnimationPaused)
        
        //mesh.geometry.attributes.position.array
        //flag.geometry.vertices.map
        let vertices = mesh.geometry.attributes.position.array;
        for(let i = 0; i < geometry.attributes.position.count; i++){
            //vertices[ i * 3 + 2 ] += 0 - Math.random() * (size / 4);
            //console.log(i,geometry.attributes.position.count)
            const x= vertices[ i * 3 + 0 ]
            //const y= vertices[ i * 3 + 1 ]
            //const z= vertices[ i * 3 + 2 ]

            const waveX0 = 0.08 * Math.sin(x + t * -1.5)
            vertices[ i * 3 + 2 ] = waveX0;
        }

        // flag.geometry.attributes.position.array.map(v => {
        //     const waveX0 = 0.2 * Math.sin(v.x + t * -2.5)
        //     //const waveX1 = 0.75 * Math.sin(v.x * 2 + t * 3)
        //     //const waveX2 = 0.25 * Math.sin(v.x * 3 + t * 2)
        //     //const waveY1 = 0.1 * Math.sin(v.y * 5 + t * 0.5)
        //     //const multi = (v.x + 2.5) / 5
            
        //     //v.z = (waveX1 + waveX2);// + waveY1);// * multi
        //     v.z = waveX0;
        // })
        
        //flag.geometry.verticesNeedUpdate = true
        mesh.geometry.attributes.position.needsUpdate = true;
        
        // test fade animations... works
        //console.log("fading out", fadeOut)
        if(fadeOut.current) {                
            //console.log("fading out", fadeOut.current)
            // const opacity = mesh.material.opacity-fadeSpeed
            // if(opacity < 0) {
            //     // test swapping the material
            //     mesh.material = (mesh.material == materialA) ? materialB : materialA
            //     mesh.material.opacity = 0.0
            //     // fadeOut = false;
            //     setFadeOut(false);
            //     setFadeIn(true);
                
            // } else {
            //     mesh.material.opacity = opacity
            //     //object.material.opacity = 0.5;
            // }

            mesh.material = (mesh.material == materialA) ? materialB : materialA
            mesh.material.opacity = 0.0
            setFadeOut(false);
            setFadeIn(true);
        }
        if(fadeIn.current) { 
            //console.log("fading in", fadeIn.current)
            const opacity = mesh.material.opacity+fadeSpeed 
            if(opacity >= 1) {
                mesh.material.opacity = 1.0
                setFadeIn(false);
                setFadeOut(false);
            } else {
                mesh.material.opacity = opacity
            }
        }


        // test rotation
        if(false) {
            //flag.geometry.mesh.rotation.x += 0.01
            mesh.rotation.y += 0.01; //= Math.PI / 2;
        }
        
        
        
        animReq.current = requestAnimationFrame( animate ); //animReq = 
        //console.log(animReq)
        renderer.render( scene, camera );        
    }
    

    useEffect(() => {
        console.log("ThreeFlag", props)
        //setIsThreeFlagLoading(true)
        props.stateChanger(true)

        // just pass in the size to avouid preloading drama
        // need to scale these to 820x410 ratios
        //const scale = 1.0; //498/props.size.height; // 996/props.size.width; // 410/props.size.height
        //729x300 = 100, 600x300 = 5
        // remap to 996x410 = 100, 820x410 = 5
        const upscale = 300/props.size.height;
        const resizedH = (upscale) * props.size.height; // scale height up to 996
        const resizedW = (upscale) * props.size.width;
        const scale = 300/props.size.height; //996/props.size.width; //498/props.size.height; // 
        maxw = (scale) * props.size.width; //996; //*(729/600); //0.9; //scale; //props.size.width*scale; //996; // props.size.width*scale
        maxh = (scale) * props.size.height; //410; //props.size.height*scale; //*scale; //498; //*scale; //
        const ratio = maxw/maxh
        const aspectRaio = 729/300;// 996/410;
        console.log("scale:", scale, maxw, props.size.width, maxh, "ratio:", ratio);
        console.log("resizedW", resizedW, resizedH)
        // $5: 1.66 996 600 498 2
        // $100: 1.3662551440329218 996 729 409.87654320987656 2.4299999999
        // scale: 1.3662551440329218 996 729 409.87654320987656 ratio: 2.4299999999999997

        // preload the first image so we get the correct aspect ratio
        // need to sync load both textures before adding to dom
        // https://stackoverflow.com/questions/42097329/synch-vs-asynch-texture-loading-in-three-js
        let urls = [props.src, props.srcflip]
        loadTextures(urls, function(error, textures) {
            if (error || textures.length < 2) {
                console.log("loadTextures", error, textures.length);
                props.stateChanger(false)
                return;
            }

            // Main code goes here using the textures array
            console.log("preloaded threejs textures", textures.length)
            //sceneReady()
            //mountRef.current.appendChild( renderer.domElement );
            imageA = textures[0]
            imageB = textures[1]

            // blurry image quality on mobile: https://stackoverflow.com/questions/42907919/three-js-image-quality-blured
            // this looks horrible on ios
            //imageB.generateMipmaps = false;
            //imageB.minFilter = THREE.LinearFilter;
            
            materialA = new THREE.MeshBasicMaterial({ 
                map: imageA,
                transparent: true,
                opacity: 1.0
            });
            //console.log("imageA", imageA.source, imageA.source.data.naturalWidth)
            //var imageB = loader.load(props.srcflip)
            materialB = new THREE.MeshBasicMaterial({ 
                map: imageB,
                transparent: true,
                opacity: 1.0
            });
            //material.transparent = true;
            //material.opacity = 0.5;
            console.log("src", props.src)
            //var material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
            //var cube = new THREE.Mesh( geometry, material );

            mesh = new THREE.Mesh( geometry, materialA );
            scene.add( mesh );
            //camera.position.z = 5.2;//2.8; //(maxh == 498) ? 2.2 : 2.0; // $5 = 2.2, $100 = 
            //camera.position.z = mapValue(maxw, 820, 910, 5.7, 5.2 );// 5.2; //6.0; //(maxh == 410) ? 5.2 : 1.0; // $5 = 2.2, $100 = 
            camera.position.z = mapValue(maxw, 600, 720, 5.8, 4.9 );
            //console.log(mesh.geometry)
            //scene.add( cube );
            //camera.position.z = 5;
            if(fadeIn.current) {
                // on first launch we want to fade this in from 0
                mesh.material.opacity = 0.0
            }
            
            // setTimeout(() => {
            //     setIsThreeFlagLoading(false)
            //     console.log("Threeflag loaded event", isThreeFlagLoading)                
            // },5000);
            //setIsThreeFlagLoading(false)
            props.stateChanger(false)

        });
        /*
        var loader = new THREE.TextureLoader()
        var imageA = loader.load(props.src)
        // var imageA = loader.load(props.src, function ( tex ) {
        //     // tex and texture are the same in this example, but that might not always be the case
        //     console.log( tex.image.width, tex.image.height );
        //     console.log( imageA.image.width, imageA.image.height );
        // } );
        var imageB = loader.load(props.srcflip)
        */


        //const w = maxw;
        const w = (window.innerWidth < maxw) ? window.innerWidth : maxw;
        const h = maxh;

        scene = new THREE.Scene();
        camera = new THREE.PerspectiveCamera( 30, ratio, 0.1, 1000 );
        renderer = new THREE.WebGLRenderer({
            alpha: true,
            antialias: true
        });

        renderer.setSize( w, h );
        mountRef.current.appendChild( renderer.domElement );

        
        const planeWidth = 6;
        const planeHeight = 6/ratio; // 3; //ratio; //Math.ceil(ratio); //3;
        geometry = new THREE.PlaneGeometry(planeWidth, planeHeight, 20, 20);
        
        
        
        clock = new THREE.Clock()
        

        let onWindowResize = function () {
            //const w = (window.innerWidth < maxw) ? window.innerWidth : maxw;
            //const h = w/2;
            const screenWidth = window.innerWidth-((isSmall) ? 80 : 0);
            const w = (screenWidth < maxw) ? screenWidth: maxw;
            const h = w/ratio; //(window.innerWidth < maxw) ? maxh/ratio : maxh;
            camera.aspect = w/h;// window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize( w, h );

            //camera.position.z = mapValue(w, 820, 910, 5.7, 5.2 );
        }

        

        window.addEventListener("resize", onWindowResize, false);
        onWindowResize()

        animate();

        // setTimeout(() => {
        //     setIsThreeFlagLoading(false)
        //     console.log("Threeflag loaded event", isThreeFlagLoading)
            
        // },2000);
        //setIsThreeFlagLoading(false)

        return () => {
            if(animReq.current) cancelAnimationFrame(animReq.current);
            if(mountRef.current) {
                mountRef.current.removeChild( renderer.domElement);
            }
            while(scene.children.length > 0){ 
                scene.remove(scene.children[0]); 
            }
            scene = null;
            renderer = null;
            geometry = null;
            mesh = null;
            clock = null;
            //delete scene;
            //delete renderer;
            
        }

  }, [isAnimationPaused]);

//   useEffect(() => {
//         console.log("isAnimationPaused", isAnimationPaused, animReq.current)
//         // FIXME: need to override the animate function
//         if(animReq.current) cancelAnimationFrame(animReq.current);
//         //animate();

//     }, [isAnimationPaused]);


  return (
    <div className={isSmall ? "px-[40px]" : ""} ref={mountRef}>
    </div>
  )
//}
})

// export default SlidesScroller 
export {
    ThreeFlag
}
